import { useNavigate } from 'react-router-dom'
import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'
import { Button } from '@/components/ui/button'

function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <SiteLayout footerVariant="minimal">
      <Seo
        title="Page not found"
        description="The page you’re looking for doesn’t exist on Tillio POS."
        path="/404"
      />
      <section className="flex items-center justify-center px-6 py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="text-center max-w-lg">
          <p className="text-sm font-semibold tracking-widest text-primary uppercase mb-4">404</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Page not found</h1>
          <p className="text-lg text-muted-foreground mb-10 leading-relaxed">
            The page you&apos;re looking for doesn&apos;t exist or may have been moved.
            Head back home to keep exploring Tillio POS.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" onClick={() => navigate('/')}>Back to Home</Button>
            <Button size="lg" variant="outline" onClick={() => navigate('/onboarding')}>Get Started</Button>
          </div>
        </div>
      </section>
    </SiteLayout>
  )
}

export default NotFoundPage
